import React from 'react';
import { useSelector } from 'react-redux';
import { Body, Stack } from '@qred/components-library';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store/types/sharedTypes';
import { ComponentSize } from '~/styles/BaseStyledComponents';
import { theme } from '~/styles/themes';
import { formatOrganizationNumber } from '~/helpers/formatters.helper';
import { getCurrency } from '@qred/shared-component-library/src/currency';

import Icon, { SvgSrc } from '~/components/shared/Icon/Icon';
import {
  ListItem,
  BoldSpan,
  UnorderedListContainer,
  BoldSpanNoLetterSpacing,
} from './CardOfferView.styled';

interface cardOfferListType {
  id: string;
  content: string | JSX.Element[] | JSX.Element;
}
const CardOfferView = () => {
  const translate = useTranslate();

  const {
    cardOnboardingOffer: { overview },
    intl: { market },
  } = useSelector((state: RootState) => state);

  const companyName = overview?.companyName;
  const companyNo = overview?.companyNo;
  const companyAddress = overview?.invoiceAddress;
  const interestRate = overview.interest || '';

  const listItems: cardOfferListType[] = [
    {
      id: 'cash-back-item',
      content: translate('OnboardingCardOffer.BenefitsCashback', {
        onePercentPlaceholder: <BoldSpan>1%</BoldSpan>,
      }),
    },
    {
      id: 'zero-interest-item',
      content: (
        <>
          {translate('CreditCardDetailsCard.MonthlyInterest')}
          <BoldSpanNoLetterSpacing> {interestRate}%</BoldSpanNoLetterSpacing>
        </>
      ),
    },
    {
      id: 'partial-payment-item',
      content: (
        <>
          <BoldSpanNoLetterSpacing>
            0 {getCurrency(market).unit}{' '}
          </BoldSpanNoLetterSpacing>
          {translate('CreditCardDetailsCard.YearlyMonthlyFee')}
        </>
      ),
    },
    {
      id: 'collect-receipts-item',
      content: translate('OnboardingCardOffer.BenefitsCollectReceipts', {
        qredAppPlaceholder: (
          <BoldSpanNoLetterSpacing>
            {translate('OnboardingCardOffer.qredApp')}
          </BoldSpanNoLetterSpacing>
        ),
      }),
    },
  ];

  return (
    <Stack spacing={'xl'}>
      <Body size="lg">
        {translate('OnboardingCardOffer.Text1', {
          companyName: companyName,
          organizationNumber: formatOrganizationNumber(companyNo || ''),
          companyAddress: companyAddress,
        })}
      </Body>
      <UnorderedListContainer>
        {listItems.map((item) => (
          <ListItem key={item.id}>
            <div>
              <Icon
                src={SvgSrc.CheckCircle}
                color={theme.colors.midwaySuccess}
                mr={0.6}
                size={ComponentSize.Small}
              />
            </div>
            <Body size="lg">{item.content}</Body>
          </ListItem>
        ))}
      </UnorderedListContainer>
    </Stack>
  );
};

export default CardOfferView;
